import { makeStyles, Switch } from '@material-ui/core'
import clsx from 'clsx'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { mapSwitchStyles } from './styles'

const useStyles = makeStyles((theme) => ({
  sydSwitch: mapSwitchStyles(theme, {})
}))

const SydSwitch = forwardRef(function SydSwitch ({
  className,
  name,
  onChange = noop,
  onBlur = noop,
  value: _value,
  defaultValue = false,
  disabled = false,
  size = 'lg',
  label,
  color = 'primary'
}, ref) {
  const classes = useStyles({ size, disabled })
  const [value, setValue] = useState(defaultValue)

  useImperativeHandle(ref, () => ({
    clear: () => setValue(defaultValue),
    focus: () => {},
    value
  }), [value, defaultValue])

  const handleChange = useCallback((event) => {
    const newValue = event.target.checked
    setValue(newValue)
    onChange(event, newValue)
  }, [setValue, onChange])

  const handleBlur = useCallback((event) => {
    onBlur(event)
  }, [onBlur])

  useEffect(() => {
    if (_value === undefined) return
    if (value === _value) return
    setValue(_value)
  }, [_value, value, setValue])

  return (
    <Switch
      className={clsx(classes.sydSwitch, className)}
      name={name}
      checked={_value !== undefined ? _value : value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      color={color}
      disableRipple
      focusVisibleClassName={classes.focusVisible}
      inputProps={{ 'aria-label': label }}
    />
  )
})

SydSwitch.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  label: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'default'])
}

SydSwitch.defaultProps = {
  defaultValue: false,
  disabled: false,
  size: 'lg',
  color: 'primary'
}

export default SydSwitch
